module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABNElEQVQokZXRMUvVcRTG8c//39XAwSAQfAEGvQIHCUQ4g7YHIW6CS4hBOXaHBndfQbU0pFuEyO9souLqlEEQODlIBBGI1W3wf+Fy0e71gR/8eDjf8xzOqTqdjq4ycw5PsRURmZltLOJDRLT1qerCmTmOg+bdwWOc4wXeYD8invTCdc+/jeOIWMEFJjEdEbt4iIXM3L4p+QgzWMdyRDzoHzMzv2AnItagKqXcwwbmkFjFEr7hfg/7vZlmq6nfrEopHzGOU0zhK35hoj+5aTDaNPnTwt2ImL2m8L/KzO0aPzJz7LYwfrZQuTrNoKTXmMbziPiMqh7AdMFnmMc7vG/sy6FgHOMMj/Cp8eqh4IjYw0scRsSrxm610MHlEA1OcNJj/a1d3Wzgwq7RRFVKeYsR/L4lPPIPKLZgbG9CMbQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/58.png
// module id = LfAQ
// module chunks = 0